import axios from "axios";

export default {
    namespaced: true,
    state() {
        return {
            allUserRoles: [],
            allModules: [],
            allLockedLogins: [],
            allLoginRecords: [],
            lockedUserLogins: [],
        };
    },
    getters: {
        allUserRoles: (state) => state.allUserRoles,
        allModules: (state) => state.allModules,
        allLockedLogins: (state) => state.allLockedLogins,
        allLoginRecords: (state) => state.allLoginRecords,
        lockedUserLogins: (state) => state.lockedUserLogins
    },
    actions: {
        async getAllUserRoles({ commit }) {
            //fetch list of all quotes
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-all-user-roles").then((data) => {
                    commit("setAllUserRoles", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getAllModules({ commit }) {
            //fetch list of all quotes
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-all-modules").then((data) => {
                    commit("setAllModules", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async updateUserRoleModules({ commit, dispatch }, request) {
            //update quote status
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-user-role-modules", request)
                    .then((data) => {
                        dispatch("getAllUserRoles");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async getAllLockedLogins({ commit }) {
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.get("/api/get-all-locked-logins").then((data) => {
                    commit("setAllLockedLogins", data.data.result);
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = "/";
                console.log(error);
            }
        },
        async getLockedUserLogins({ commit }, { page = 1, search = ''}) {
            try {
                window.emitter.emit("changeLoaderStatus", true);

                await axios.get("/api/settings/locked-logins", {
                  params: {
                    page: page,
                    search: search
                  }
                }).then((data) => {

                  commit("SET_LOCKED_USER_LOGINS", {data: data.data});

                  window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                console.log(error);
            }
        },
        async updatLockedLogin({ commit, dispatch }, request) {
            //update quote status
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios
                    .post("/api/update-locked-login", request)
                    .then((data) => {
                        dispatch("getAllLockedLogins");
                        window.emitter.emit("changeLoaderStatus", false);
                    });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async deleteLockedLogin({ commit, dispatch }, request) {
            //delete order
            try {
                window.emitter.emit("changeLoaderStatus", true);
                await axios.post("/api/delete-locked-login", request)
                .then((data) => {
                    // dispatch("getAllLockedLogins");
                    window.emitter.emit("changeLoaderStatus", false);
                });
            } catch (error) {
                // window.location.href = '/';
                console.log(error);
            }
        },
        async getAllLoginRecords({ commit }, { page = 1, search = "" } = {}) {
            try {
                window.emitter.emit("changeLoaderStatus", true);

                const response = await axios.get("/api/login-records", {
                    params: {
                      page: page,
                      search: search,
                    },
                });

                commit("SET_LOGIN_RECORDS", {
                    data: response.data
                });

                return response.data
            } catch (error) {
                console.log(error);
            } finally {
                window.emitter.emit("changeLoaderStatus", false);
            }
        },
    },
    mutations: {
        setAllUserRoles(state, allUserRoles) {
            state.allUserRoles = allUserRoles;
        },
        setAllModules(state, allModules) {
            state.allModules = allModules;
        },
        setAllLockedLogins(state, allLockedLogins) {
            state.allLockedLogins = allLockedLogins;
        },
        SET_LOGIN_RECORDS(state, { data }) {
            state.allLoginRecords = data;
        },
        SET_LOCKED_USER_LOGINS(state, { data }) {
          state.lockedUserLogins = data;
        }
    },
};
